const propertyData = {
  name: "Stalley Beach House",
  tagline: "Beachfront, 6bd, Pool, Maid, Cook, SUV's, 7 Kayaks",
  location: {
    address: "9 miles north of Jacó",
    city: "Jacó",
    state: "Puntarenas",
    country: "Costa Rica",
    coordinates: { lat: 9.726241955692945, lng: -84.65024484160182 },
  },
  highlights: {
    guests: 12,
    bedrooms: 6,
    // TODO: Update with actual bathroom count from your listing
    bathrooms: 3.5,
    rating: 4.96,
    reviews: 255,
  },
  description: `One of the very best beachfront properties in Costa Rica, located in the heart of the most popular tourist area in Costa Rica (9 miles north of Jaco). Quiet and exceptional beautiful views and area, with private pool, ping-pong, climbing peg board, foosball, 7 ocean kayaks, outdoor fire pit area, badminton, tire swing, dart board, and board games. SUVs are available for guest use during your stay, and our cook is usually available for an extra charge.

This is an exceptional very large residential beachfront property, and beach area, with a great beautiful 2 mile beach walk to the north. I have had people tell me (including Costa Ricans), that this is the most beautiful beachfront property they have seen in Costa Rica.

Our beach is the best place I have seen, for kayaking in Costa Rica. People can kayak from our beach, to a white sand beach, that is 1 mile to the south (7 kayaks are included, when renting for 5 or more days, 2 tandem, and 5 singles.). We have high speed dependable 98 Mbps internet.

We have dining tables on the front porch, with seating for 18 guests. There are several great restaurants, and fun tours in our immediate area, and Jaco is just an easy 15 minute drive to the south. There is a large in house apple imac computer. There is parking for 4 cars, up the driveway right behind the house. We have a small legal car rental company. Please write us about the car rentals, which includes the large passenger van with driver, to shuttle your group from the airport, and back to the airport when you depart.

Other things to note
Please reach out with any questions about what we offer with the house. My wife, son, and I live on the property full time in a separate house.`,
  amenities: [
    {
      category: "Beach & Water",
      icon: "kayaking",
      items: [
        "Direct beachfront access",
        "7 ocean kayaks (stays of 5+ days)",
        "Surfing nearby",
        "Stunning ocean views",
      ],
    },
    {
      category: "Pool & Outdoor",
      icon: "pool",
      items: ["Private swimming pool", "Outdoor fire pit area", "Badminton court", "Tire swing"],
    },
    {
      category: "Games & Entertainment",
      icon: "sports_esports",
      items: [
        "Ping-pong table",
        "Foosball table",
        "Climbing peg board",
        "Dart board",
        "Board games",
      ],
    },
    {
      category: "Services & Transport",
      icon: "directions_car",
      items: [
        "Maid service included (stays 5+ days)",
        "Cook available (extra charge)",
        "SUVs provided for guest use",
        "Secure parking",
      ],
    },
  ],
  // TODO: Update these with your actual house rules from Airbnb
  houseRules: [
    "Maximum occupancy: 14 adults",
    "No smoking inside the property",
    "No parties or events without prior approval",
    "No outside guests allowed on the property",
  ],
};

export default propertyData;
